// extracted by mini-css-extract-plugin
export default {"container":"projects_container__H2JV6","project":"projects_project__CGmij"};